module.exports = __webpack_public_path__ + "static/media/7.0c95ef44.PNG";